"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var BaobabInjectorButton = (function (_super) {
    __extends(BaobabInjectorButton, _super);
    function BaobabInjectorButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getBundleUrl = function () { return "https://frontend-internal.s3.mds.yandex.net/baobab-viewer/" + _this.props.version + "/button.js"; };
        return _this;
    }
    BaobabInjectorButton.prototype.componentDidMount = function () {
        var script = document.createElement('script');
        script.src = this.getBundleUrl();
        script.async = true;
        script.id = 'BaobabViewerInject';
        script.dataset.version = this.props.version;
        script.dataset.service = this.props.service;
        script.dataset.positionX = this.props.positionX;
        script.dataset.positionY = String(this.props.positionY);
        document.body.appendChild(script);
    };
    BaobabInjectorButton.prototype.render = function () {
        return null;
    };
    BaobabInjectorButton.defaultProps = {
        version: '0.3.0',
        positionX: 'left',
        positionY: 0,
    };
    BaobabInjectorButton.useLogger = function (logger) {
        window.__baobabLogger = logger;
    };
    return BaobabInjectorButton;
}(React.Component));
exports.BaobabInjectorButton = BaobabInjectorButton;
